"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizedCachedDimensions = void 0;
var image_sizes_1 = require("../constants/image-sizes");
var lodash_1 = require("lodash");
var isGif = function (coverUrl) { return /.gif$/.test(coverUrl); };
var round100 = function (width, height) {
    return Math.round((width / height) * 100) / 100;
};
var cache = {};
function getNormalizedCachedDimensions(coverUrl, _a) {
    var containerWidth = _a.containerWidth, containerHeight = _a.containerHeight;
    var aspectRatio = round100(containerWidth, containerHeight);
    var cachedSizes = (0, lodash_1.get)(cache[aspectRatio], [coverUrl]);
    var loadedImageWidth = (0, lodash_1.get)(cachedSizes, 'width', 0);
    var loadedImageHeight = (0, lodash_1.get)(cachedSizes, 'height', 0);
    var widthCandidate = image_sizes_1.AVAILABLE_IMAGE_WIDTH.find(function (size) { return size >= containerWidth; }) ||
        image_sizes_1.MAX_IMAGE_WIDTH;
    var width = isGif(coverUrl)
        ? image_sizes_1.MAX_IMAGE_WIDTH
        : Math.max(widthCandidate, loadedImageWidth);
    var heightCandidate = Math.round(width / aspectRatio);
    var height = Math.max(heightCandidate, loadedImageHeight);
    if (!cache[aspectRatio]) {
        cache[aspectRatio] = {};
    }
    cache[aspectRatio][coverUrl] = { width: width, height: height };
    return [width, height];
}
exports.getNormalizedCachedDimensions = getNormalizedCachedDimensions;
//# sourceMappingURL=normalize-image-dimensions.js.map